module.exports = __webpack_public_path__ + "static/media/blank-logo.6d22d48f.png";